// extracted by mini-css-extract-plugin
module.exports = {"Html":"Html_Html__FE78a","break-all":"Html_break-all__lBxmu"};